<style scoped>
    .medprofiletable {
        border-collapse: separate !important;
    }

        .medprofiletable > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
            padding: 5px;
            height: 30px;
            vertical-align: central;
        }

    th > td {
        border: 0px;
    }

    tr {
        line-height: 30px;
    }

    td {
        border: 0.5pt solid #d9d9d9;
        padding-left: 4px
    }

    tr.border_top td {
        border-top: 1.2pt solid #d9d9d9;
    }

    input {
        /*min-width: 20px;*/
        margin: 0px;
        height: 26px;
        padding: 2PX;
    }

    .no-border {
        border: 0;
        box-shadow: none; /* You may want to include this as bootstrap applies these styles too */
        margin: 1px
    }

    .headerCell {
        background: #fafafa;
        font-size: 15px;
        color: grey;
    }

    .headerLabel {
        background: #fafafa;
    }

    .Round-Rectangle {
        margin: 5px;
        width: 100px;
        height: 28px;
        border: 1px solid #d9d9d9;
    }

    .editableCell {
        padding: 0px;
    }

    .editableCellDiv {
        border: 1px gray solid;
        padding: 2px;
        margin: 0px;
    }

    #foo {
        position: fixed;
        bottom: 0;
        right: 0;
        pointer-events: none;
    }


    .vcenter {
        display: inline-block;
        vertical-align: middle;
        float: none;
    }
</style>
<template>
    <div class="col-md-12">

        <!--<LoaderControl :loading="this.controlLoading">-->
        <!--<br />
        <table>
            <tr>
                <td style="border:none"><ScheduleSelector class="vcenter"></ScheduleSelector></td>
                <td style="border:none"class="vcenter"><RoundSelector ></RoundSelector></td>
            </tr>
        </table>-->
        <br />
        

        <div class="row" style="margin-top:5px">
            <div class="col-xs-6">
                <a href="#" class="btn btn-primary btn-sm" v-on:click.prevent="controller.CheckinAllItems"><i class="fa fa-check-circle" />   Confirm Check-in (All)</a>
            </div>
            <div class="col-xs-6">
                <ul class="nav nav-pills pull-right">
                    <li class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                            <strong>{{currentCycleTitle}}</strong> ( {{formatDate(controller.CurrentStartDate)}} - {{formatDate(controller.CurrentEndDate)}} )<span class="caret"></span>
                        </a>
                        <ul class="dropdown-menu">
                            <template v-for="(cycle, index) in controller.Cycles">
                                <template v-if="index==0">
                                    <li>
                                        <a @click.prevent.self="controller.setCycle(cycle)">
                                            <strong class="text-primary">Next</strong><br />
                                            {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                        </a>
                                    </li>
                                    <li class="divider"></li>
                                </template>

                                <template v-if="index==1">
                                    <li>
                                        <a @click.prevent.self="controller.setCycle(cycle)">
                                            <strong class="text-danger"> Current</strong><br />
                                            {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                        </a>
                                    </li>
                                    <li class="divider"></li>
                                </template>

                                <template v-if="index>1">
                                    <li>
                                        <a @click.prevent.self="controller.setCycle(cycle)">
                                            {{formatDate(cycle.startDate)}} - {{formatDate(cycle.endDate)}}
                                        </a>
                                    </li>
                                </template>
                            </template>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <table width="100%" class="medprofiletable">
                <!--  border="1" cellpadding="4" cellspacing="0" style="border: 1px solid  #eeeeee;" -->
                <thead>
                    <tr>
                        <th width="400px">Drug ({{controller.Items ? controller.Items.length : ""}})</th>
                        <th width="100px">Drug Image</th>
                        <th style="width:110px">Rounds</th>

                        <th> </th>
                        <th> </th>
                        <th> </th>
                        <th> </th>

                        <th  style="width:120px"></th>
                        <th style="width:100px">Date</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>

                    <template v-for="(item, index) in controller.Items">
                        <tr class="border_top">
                            <td class="headerCell" rowspan="4" style="vertical-align:text-top">
                                <div v-if="item.medProfile.checkedIn" class="col-xs-12" style="padding-left:0px">
                                    <a href="#" class="btn btn-success btn-xs disabled"><i class="fa fa-check" />   Checked In</a>
                                    <span v-if="item.changed" class="label label-warning pull-right" style="margin:3px">Pending Save</span>
                                </div>
                                <div v-else class="col-xs-12" style="padding-left:0px">
                                    <a v-on:click.prevent="item.checkedIn = !item.checkedIn"
                                       class="btn btn-primary btn-xs"
                                       v-bind:class="{'btn-primary' : !item.checkedIn, 'btn-warning' : item.checkedIn}">
                                        <i class="fa fa-check" />   {{ item.checkedIn ? "Checked In" : "Confirm Check-in"}}
                                    </a>
                                    <span v-if="item.changed" class="label label-warning pull-right" style="margin:3px">Pending Save</span>
                                </div>
                                <p v-bind:class="{'text-warning': item.changed}">
                                    <small>({{index+1}})</small> <strong>{{item.medProfile.drugName}}</strong><br />
                                    {{item.medProfile.dosageInstruction}}
                                </p>

                            </td>
                            <td class="headerCell" rowspan="4"><img v-if="item.medProfile.drugImageId" v-bind:src="'api/image?id='+item.medProfile.drugImageId" style="max-height:100px"></td>
                            <td class="headerCell text-center " rowspan="4" style="vertical-align:text-top; text-align: center; ">
                                <template v-for="round in item.medProfile.medRounds">
                                    <div class="Round-Rectangle" v-bind:style="{ background: HexColour(round.colourHex) }">
                                        <span style="vertical-align:central; color:white"><strong>{{round.roundTime}}</strong></span>
                                    </div>
                                </template>

                            </td>

                            <td class="headerLabel"><small>Sent </small></td>
                            <td class="headerLabel"><small>Received</small> </td>
                            <td class="headerLabel" v-bind:class="{ 'text-warning':  item.broughtForwardChanged }"><small>B'Forward</small> </td>
                            <td class="headerLabel"><small>Total </small></td>

                            <td class="headerLabel"><small>Sign         </small></td>
                            <td class="headerLabel"><small>Date         </small></td>
                            <td class="headerLabel"><small>Indications  </small></td>
                        </tr>
                        <tr>
                            <td class="headerCell text-primary">{{item.medProfile.sent}}</td>
                            <!--<td><input class="form-control no-border" v-model="item.medProfile.sent" readonly /></td>-->
                            <td style="border:1px solid black;padding:2px; border-right:0px;"><input class="form-control no-border" v-model="item.received.value" /></td>
                            <td style="border:1px solid black;padding:2px">
                                <input class="form-control no-border" v-model="item.broughtForward.value" v-bind:class="{ 'text-warning':  item.broughtForwardChanged }" />
                            </td>

                            <td class="headerCell">{{+item.broughtForward.value + +item.received.value}}</td>

                            <td class="headerCell">{{item.medProfile.checkedInUser}}</td>
                            <td class="headerCell"><small>{{formatDateTime(item.medProfile.deliverySignTimeStamp)}}</small></td>
                            <td class="headerCell"></td>
                        </tr>
                        <tr>
                            <!--<td class="headerCell" rowSpan="2"></td>-->
                            <td class="headerLabel" v-bind:class="{ 'text-warning':  item.takenChanged }"><small>Taken </small></td>
                            <td class="headerLabel" v-bind:class="{ 'text-warning':  item.returnedChanged }"><small>Returned</small></td>
                            <td class="headerLabel" v-bind:class="{ 'text-warning':  item.destroyedChanged }"><small>Destroyed</small></td>
                            <td class="headerLabel"><small>C'Forward</small></td>
                            <td class="headerLabel"><small>Signed  </small></td>
                            <td class="headerLabel"><small>Date  </small></td>
                            <td class="headerLabel"><small>Routes</small></td>
                        </tr>
                        <tr>
                            <td style="border:1px solid black;padding:2px; border-right:0px;"><input class="form-control no-border" v-bind:class="{ 'text-warning':  item.takenChanged }" v-model="item.taken.value" /></td>
                            <td style="border:1px solid black;padding:2px; border-right:0px;"><input class="form-control no-border" v-bind:class="{ 'text-warning':  item.returnedChanged }" v-model="item.returned.value" /></td>
                            <td style="border:1px solid black;padding:2px;"><input class="form-control no-border" v-bind:class="{ 'text-warning':  item.destroyedChanged }" v-model="item.destroyed.value" /></td>

                            <td class="headerCell text-primary">{{item.carryForwardCalculated}}</td>

                            <td class="headerCell">{{item.medProfile.medicineReturnedUser}}</td>
                            <td class="headerCell"><small>{{formatDateTime(item.medProfile.returnSignTimeStamp)}}</small></td>
                            <td class="headerCell"></td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <hr />
        <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
            <!--<a class="btn btn-primary" :disabled="controller.hasError" @click.prevent.self="save()">Submit</a>-->
            <WorkerButton :disabled="controller.hasError" :submit="save" task="Med Profile Saved"></WorkerButton>
            <a href="#" class="btn btn-warning" @click.prevent.self="Reset">Reset</a>
            <span class="help-block">{{controller.message}}</span>
        </div>
        <div id="foo" v-if="controller.ChangeCount > 0">
            <div class="alert alert-dismissible alert-warning" style="margin:10px; opacity:0.6">
                <!--<button type="button" class="close" data-dismiss="alert">&times;</button>-->
                <strong>{{controller.ChangeCount}} Pending Changes. </strong><br /> Press submit to save.
            </div>
        </div>
    </div>
</template>
<script>
    import { MedProfileDto, MedRoundDto } from './../../../dto/Dtos';
    import Formatter from "../../corecontrols/formatters/Formatter";
    import WorkerButton from "../../corecontrols/workerbutton/workerbutton.scp.html";
   
    import MedProfileController from "./medProfileController"
    import Dal from './../../../scripts/dataaccess';
    export default {
        props: ['patientid'],
        data: function () {
            return {
                cycleStartDate: undefined,
                cycleEndDate: undefined,
                currentCycleTitle: "",
                cycles: [],
                controller: {},
                isLoading: true,
                patient: {}
            }
        },
        methods: {
            formatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            formatDateTime: function (dt) {
                return Formatter.FormatDateTime(dt);
            },
            HexColour: function (argb) {
                //console.log(argb, '#' + ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6));
                var rgb = '#' + ('000000' + (argb & 0xFFFFFF).toString(16)).slice(-6);
                //console.log('#' + argb.substring(3, 9));
                //return "#e1e1e1";
                return '#' + argb.substring(3, 9);
            },
            setCycle: function (cycle) {
                this.currentCycleTitle = this.cycles.indexOf(cycle) == 0 ? "Next Cycle" : this.cycles.indexOf(cycle) == 1 ? "Current Cycle" : " Cycle";
                this.cycleStartDate = cycle.startDate;
                this.cycleEndDate = cycle.endDate;
                this.load();
            },
            Reset: function () {
                this.controller = new MedProfileController(this.patientid);
            },
            load: function () {

                //console.log("Mounting Patient Med Profile", this.$props.patientid, this.$props.startDate, this.$props.endDate)

                console.log("Mounting Patient Med Profile", this.$props.patientid)


                if (this.$props.patientid) {
                    var dal = new Dal();

                    dal.GetPatient(this.$props.patientid).then(p => {
                        this.patient = p;

                        dal.GetWardCycles(this.patient.wardId).then(cycles => {
                            var sortedCycles = cycles.sort((n1, n2) => {
                                if (n1.startDate > n2.startDate) return -1;
                                else if (n1.startDate < n2.startDate) return 1;
                                else return 0;
                            });

                            this.cycles = sortedCycles;


                            if (!this.cycleStartDate || !this.cycleEndDate) {

                                this.cycleStartDate = sortedCycles[1].startDate;
                                this.cycleEndDate = sortedCycles[1].endDate;
                                this.currentCycleTitle = "Current Cycle"
                            }
                            this.controlLoading = false;
                            this.Load(this.patient.id, this.cycleStartDate, this.cycleEndDate);
                            this.isLoading = false;
                        });
                    });
                }

            },
            save: function () {
                var that = this;
                return this.controller.Save();
            }
        },
        mounted: function () {
            this.controller = new MedProfileController(this.patientid);
            //this.load();
            //this.controller.Initialize();
        },
        watch: {
            startDate: function () { this.load() },
            endDate: function () { this.load() },
            patient: function () { this.load() }
        },
        components: {
            WorkerButton,
        }
    }
</script>


// WEBPACK FOOTER //
// PatientMedProfileForm.scp.html?232f09a5